import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  href: string;
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  /** true abre el checkout en otra pestaña; false para anclas internas. */
  external?: boolean;
  className?: string;
}
export function CtaButton({
  children,
  href,
  size = 'lg',
  fullWidth = true,
  external = true,
  className = ''
}: CtaButtonProps) {
  const sizes = {
    md: 'px-6 py-4 text-sm md:text-base',
    lg: 'px-7 py-5 text-base md:text-lg',
    xl: 'px-8 py-6 text-lg md:text-xl'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center rounded-xl bg-cta text-center font-display font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-cta-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-152" data-mp="1shorah56usj1">
      {children}
    </a>;
}